package com.partejar.app.feature.auth.state

import com.partejar.app.core.session.SessionDestination

data class AuthState(
    val nome: String = "",
    val email: String = "",
    val senha: String = "",
    val confirmacaoSenha: String = "",
    val isRegistration: Boolean = false,
    val isLoading: Boolean = false,
    val erro: String? = null,
    val destination: SessionDestination? = null
)
